const ACTIVITY_TYPES = {
    'lead-created': 'Lead Created',
    'leads-imported': 'Leads Imported',
    'couple-added': 'Couple Added from Inquiry Form',
    'couple-duplicate': 'Duplicate Couple Inquiry',
    'wedding-deleted': 'Wedding Deleted',
    'invoice-created': 'Invoice Created',
    'invoice-edited': 'Invoice Edited',
    'invoice-deleted': 'Invoice Deleted',
    'payment-created': 'Payment Created',
    'payment-edited': 'Payment Edited',
    'payment-deleted': 'Payment Deleted',
    'ceremony-edited': 'Ceremony Edited',
    'wedding-status-edited': 'Wedding Status Edited',
    'wedding-officiant-set': 'Wedding Officiant Set',
    'approval-reset': 'Wedding Approval Reset',
    'admin-changed-user-password': 'Admin Changed User Password',
    'event-created': 'Event Created',
    'event-edited': 'Event Edited',
    'event-deleted': 'Event Deleted',
    'unavailability-created': 'Unavailability Created',
    'unavailability-edited': 'Unavailability Edited',
    'unavailability-deleted': 'Unavailability Deleted',
    'admin-created-wedding-planner': 'Admin Created Wedding Planner',
    'admin-created-user': 'Admin Created User',
    'admin-edited-user': 'Admin Edited User',
    'bulk-sms-sent': 'Bulk Text Messages Sent'
};

export default ACTIVITY_TYPES;
